export const formatDate = (date, showSeconds = false) => {
  const options = {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
  };

  if (showSeconds) {
    options.second = "numeric";
  }

  return new Date(date).toLocaleDateString("en-US", options);
};
